export const PASSPORT_DESTINATION_PLACEHOLDER = "/passport-destination-placeholder.svg";